"use client";

import { c as _c } from "react/compiler-runtime";
import { Plus } from "@untitledui/icons";
import type { ButtonProps as AriaButtonProps } from "react-aria-components";
import { Tooltip as AriaTooltip, TooltipTrigger as AriaTooltipTrigger } from "@/components/base/tooltip/tooltip";
import { cx } from "@/utils/cx";
const sizes = {
  xs: {
    root: "size-6",
    icon: "size-4"
  },
  sm: {
    root: "size-8",
    icon: "size-4"
  },
  md: {
    root: "size-10",
    icon: "size-5"
  }
};
interface AvatarAddButtonProps extends AriaButtonProps {
  size: "xs" | "sm" | "md";
  title?: string;
  className?: string;
}
export const AvatarAddButton = t0 => {
  const $ = _c(20);
  let className;
  let props;
  let size;
  let t1;
  if ($[0] !== t0) {
    ({
      size,
      className,
      title: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    t1 = $[4];
  }
  const title = t1 === undefined ? "Add user" : t1;
  const t2 = sizes[size];
  let t3;
  if ($[5] !== className || $[6] !== t2.root) {
    t3 = cx("flex cursor-pointer items-center justify-center rounded-full border border-dashed border-primary bg-primary text-fg-quaternary outline-focus-ring transition duration-100 ease-linear hover:bg-primary_hover hover:text-fg-quaternary_hover focus-visible:outline-2 focus-visible:outline-offset-2 disabled:border-gray-200 disabled:bg-secondary disabled:text-gray-200", t2.root, className);
    $[5] = className;
    $[6] = t2.root;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = sizes[size];
  let t5;
  if ($[8] !== t4.icon) {
    t5 = cx("text-current transition-inherit-all", t4.icon);
    $[8] = t4.icon;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <Plus className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== t3 || $[14] !== t6 || $[15] !== title) {
    t7 = <AriaTooltipTrigger {...props} aria-label={title} className={t3}>{t6}</AriaTooltipTrigger>;
    $[12] = props;
    $[13] = t3;
    $[14] = t6;
    $[15] = title;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7 || $[18] !== title) {
    t8 = <AriaTooltip title={title}>{t7}</AriaTooltip>;
    $[17] = t7;
    $[18] = title;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};